module.exports = __webpack_public_path__ + "276070fad562f9e93298f721222acdc3.svg";